<template>
    <v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title>
                    <div class="headline">Company Search</div>
                </v-card-title>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <ais-instant-search :index-name="indexName" :search-client="searchClient" :routing="routing">
                                <ais-configure
                                        :hitsPerPage="5"
                                />
                                <ais-search-box/>
                                <ais-hits>
                                    <v-list
                                            three-line
                                            slot-scope="{ items }"
                                    >
                                        <template v-for="(item, index) in items">
                                            <v-list-tile :key="item.objectID" @click="" :to="{name: 'admin.company.profile', params: {uid: item.objectID}}" :color="currentModelVersion === item.status.version ? undefined: 'warning'">
                                                <v-list-tile-content>
                                                    <v-list-tile-title><ais-highlight attribute="profile.name" :hit="item" />{{currentModelVersion === item.status.version ? '': ' (requires profile upgrade)'}}</v-list-tile-title>
                                                    <v-list-tile-sub-title>
                                                        <ais-highlight attribute="profile.contacts.primary.firstName" :hit="item" />&nbsp;
                                                        <ais-highlight attribute="profile.contacts.primary.lastName" :hit="item" />&nbsp;&vert;&nbsp;
                                                        <ais-highlight attribute="profile.contacts.primary.email" :hit="item" />
                                                    </v-list-tile-sub-title>
                                                    <v-list-tile-sub-title>Last Modified: {{item.status.updatedHuman}} | Version: {{item.status.version || 'N/A'}}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-divider
                                                    v-if="index + 1 < items.length"
                                                    :key="index"
                                            ></v-divider>
                                        </template>
                                    </v-list>
                                </ais-hits>
                                <ais-pagination/>
                            </ais-instant-search>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import 'instantsearch.css/themes/algolia-min.css'
  import {SetDocumentTitleMixin, AlgoliaSearchMixin} from '@/views/app/mixins'

  export default {
    name: 'CompanySearch',
    mixins: [SetDocumentTitleMixin, AlgoliaSearchMixin],
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    },
    created () {
      this.init()
    },
    computed: {
      currentModelVersion () {
        return this.systemConfig.modelVersions.companies
      },
      indexName () {
        return `${this.indexPrefix}Companies`
      }
    },
    methods: {
      init () {
        this.setDocumentTitle()
        this.setupSearchClient()
      }
    }
  }
</script>

<style scoped>
</style>
